import React from 'react';

import Container from '../styles/toolbar';

export default function Toolbar() {
    return (
        <Container>
            <h1>Conways Game of Life</h1>
        </Container>
    )
}
